
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/culture-career",
      function () {
        return require("private-next-pages/culture-career.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/culture-career"])
      });
    }
  